import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';

const AnyReactComponent = ({ text }) => <div>{text}</div>;
class GoogleMapStyle extends Component {
  static defaultProps = {
      
    center: {
      lat: 35.81251384613958,
      lng: 10.638411856035063
    },
    zoom: 17
  };

  render() {
    return (
      // Important! Always set the container height explicitly
      <div className="google-map-style-1">
        <GoogleMapReact
          // bootstrapURLKeys={{ key: /* YOUR KEY HERE */ }}
          defaultCenter={this.props.center}
          defaultZoom={this.props.zoom}
        >
          <AnyReactComponent
            lat={35.81251384613958}
            lng={10.638411856035063}
            text="IEEE ISSATSo SB"
          />
        </GoogleMapReact>
      </div>
    );
  }
}

export default GoogleMapStyle;